// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickJournalDuneSunlightSlits__container___LiUW3 {
    position: absolute;
    inset: 0;
    z-index: 2;
    overflow: hidden;
    pointer-events: none;
    mix-blend-mode: screen;
}

.QuickJournalDuneSunlightSlits__beam___KqMq6 {
    position: absolute;
    top: -24%;
    bottom: -24%;
    width: 10%;
    background: linear-gradient(
        to right,
        rgba(255, 226, 157, 0) 0%,
        rgba(255, 226, 157, 0.02) 30%,
        rgba(255, 226, 157, 0.12) 44%,
        rgba(255, 226, 157, 0.24) 50%,
        rgba(255, 226, 157, 0.12) 56%,
        rgba(255, 226, 157, 0.02) 70%,
        rgba(255, 226, 157, 0) 100%
    );
    filter: blur(3px);
    opacity: 0.24;
    transform: rotate(-14deg);
    transform-origin: 50% 50%;
    animation: QuickJournalDuneSunlightSlits__quickJournalDuneSunlightBreathe___TaqQX 10.8s ease-in-out infinite;
}

.QuickJournalDuneSunlightSlits__beamOne___fhkiT {
    left: 10%;
    width: 14%;
    filter: blur(3.5px);
    animation-delay: -1.8s;
}

.QuickJournalDuneSunlightSlits__beamTwo___dKWO5 {
    left: 46%;
    width: 5%;
    filter: blur(1.5px);
    animation-duration: 13.6s;
    animation-delay: -7.2s;
}

.QuickJournalDuneSunlightSlits__beamThree___tg99V {
    left: 75%;
    width: 9%;
    filter: blur(2.5px);
    animation-duration: 16.2s;
    animation-delay: -11.4s;
}

@keyframes QuickJournalDuneSunlightSlits__quickJournalDuneSunlightBreathe___TaqQX {
    0%,
    100% {
        opacity: 0.18;
    }

    24% {
        opacity: 0.42;
    }

    49% {
        opacity: 0.23;
    }

    72% {
        opacity: 0.56;
    }

    88% {
        opacity: 0.29;
    }
}

@media (prefers-reduced-motion: reduce) {
    .QuickJournalDuneSunlightSlits__beam___KqMq6 {
        animation: none;
        opacity: 0.3;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QuickJournalDuneSunlightSlits__container___LiUW3`,
	"beam": `QuickJournalDuneSunlightSlits__beam___KqMq6`,
	"quickJournalDuneSunlightBreathe": `QuickJournalDuneSunlightSlits__quickJournalDuneSunlightBreathe___TaqQX`,
	"beamOne": `QuickJournalDuneSunlightSlits__beamOne___fhkiT`,
	"beamTwo": `QuickJournalDuneSunlightSlits__beamTwo___dKWO5`,
	"beamThree": `QuickJournalDuneSunlightSlits__beamThree___tg99V`
};
module.exports = ___CSS_LOADER_EXPORT___;
